<div class="modal-header">
    <h4 class="modal-title">Confirmar borrado</h4>
</div>
    
<div class="modal-body">

¿Estas seguro que deseas eliminar este registro?
    
</div>

    
<div class="modal-footer">

    <button type="button" (click) = "onSave()" class="btn btn-danger" >Aceptar</button>
      
    <button type="button" (click) = "onCancel()" class="btn btn-primary" >Cancelar</button>
    
</div>